export default {
	translations: {
		titles: {
			batmanTvShows: "Batman TV Shows"
		},
		placeholders: {
			searchShow: "Search show"
		}
	}
};